import { getDataSwatches } from 'hooks/useStorefront'

const fetchError = (error) => {
  console.log('error', error)
}

const fetchData = (endpoint, callback = null) => {
  return fetch(endpoint)
    .then((response) => {
      if (response.status >= 200 && response.status <= 299) {
        return response.json()
      } else {
        callback ? callback() : fetchError(response.statusText)
        throw Error(response.statusText)
      }
    })
    .then((jsonResponse) => {
      return jsonResponse
    })
    .catch((error) => {
      callback ? callback(error) : fetchError(error)
    })
}

const postData = (endpoint, body, type = 'json', callback = null) => {
  return fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: type === 'json' ? JSON.stringify(body) : body
  })
    .then((response) => {
      if (response.status >= 200 && response.status <= 299) {
        return response.json()
      } else {
        callback ? callback(response) : fetchError(response.statusText)
      }
    })
    .then((jsonResponse) => {
      return jsonResponse
    })
    .catch((error) => {
      fetchError(error)
    })
}

const fetchProductsLinked = async (products) => {
  const linkedTags = products.map(product => product.tags.find(x => x.includes('linked-')))
  const uniqueTags = [...new Set(linkedTags)]
  await getDataSwatches(uniqueTags)
}

export {
  fetchData,
  postData,
  fetchProductsLinked
}
